<template>
   <footer>
    <nav>
      <ul>
        <li><router-link to="/about">Sobre</router-link></li>
        <li><router-link to="/">Home</router-link></li>
      </ul>
    </nav>
  </footer>
</template>

<script>
export default {

}
</script>

<style lang="scss">
  footer {
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    position:static;
    bottom: 0;
    justify-content: center;

  ul {
      list-style: none;
    }
  ul li {
    display: inline-flex;
    align-self: stretch;
    margin-left: 1rem;
    float:center;
  }
}
</style>
